import { render, staticRenderFns } from "./CartHead.vue?vue&type=template&id=3799b28b&"
import script from "./CartHead.vue?vue&type=script&lang=js&"
export * from "./CartHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3799b28b')) {
      api.createRecord('3799b28b', component.options)
    } else {
      api.reload('3799b28b', component.options)
    }
    module.hot.accept("./CartHead.vue?vue&type=template&id=3799b28b&", function () {
      api.rerender('3799b28b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/CartHead.vue"
export default component.exports